<template lang="html">
	<div>
		<div class="panel panel-default">
			<div class="panel-heading">
				<span>Exports</span>
			</div>
			<div class="panel-body">
				<ul class="list-group">
				  <li class="list-group-item level jc-sb ai-c">
					  <span>PPC</span>
					  <button type="button" class="btn btn-default-outline" @click="showExportBuilder('ppc')">
	  					Export
	  				</button>
				  </li>
				  <li class="list-group-item level jc-sb ai-c">
					  <span>Google Analytics</span>
					  <button type="button" class="btn btn-default-outline" @click="showExportBuilder('ga')">
	  					Export
	  				</button>
				  </li>
				  <li class="list-group-item level jc-sb ai-c">
					  <span>Phonecalls</span>
					  <button type="button" class="btn btn-default-outline" @click="showExportBuilder('phonecall')">
	  					Export
	  				</button>
				  </li>
				</ul>
			</div>
		</div>

		<div class="modal fade" id="modal-export-builder" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="hideExportBuilder">&times;</button>

                        <h4 class="modal-title">
                            {{ heading }}
                        </h4>
                    </div>

                    <div class="modal-body">
                        <ppc-export-builder v-if="types.ppc"></ppc-export-builder>
                        <ga-export-builder v-if="types.ga"></ga-export-builder>
                        <phonecall-export-builder v-if="types.phonecall"></phonecall-export-builder>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click="hideExportBuilder">Close</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import PpcExportBuilder from './PpcExportBuilder.vue';
import GaExportBuilder from './GaExportBuilder.vue';
import PhonecallExportBuilder from './PhonecallExportBuilder.vue';

export default {
	components: { PpcExportBuilder, GaExportBuilder, PhonecallExportBuilder },

	data() {
		return {
			types: {
				ppc: false,
				ga: false
			},
			heading: '',
			headings: {
				ppc: 'Export PPC Data',
				ga: 'Export Google Analytics Data',
				phonecall: 'Export Phonecall Data',
			}
		}
	},

	created() {
		Bus.$on('hide-export-builder', this.hideExportBuilder);
	},

	methods: {
		showExportBuilder(type) {
			this.reset();
			this.types[type] = true;
			this.heading = this.headings[type];
			$('#modal-export-builder').modal('show');
		},
		hideExportBuilder() {
			$('#modal-export-builder').modal('hide');
		},
		reset() {
            Object.assign(this.$data, this.$options.data());
        }
	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/exports/ExportList.vue